"use strict";

class DeveloperARMSController {

     constructor(SSHttpService, SSUtilService, SSUserService, SSAnalyticsService) {

        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.data = SHOWSUITE.data;

        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT;
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED; // Not Listed on portal and publicly visible

        self.showArchive = false;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Arms Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_ARMS,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.getProperties();
    }

    getProperties() {
        const self = this;

        self.properties = [];

        let url = 'sec/developer/properties';
        let params = {
            summary: true
        };

        loading(true);
        this.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return;
            }

            if (response.data.properties) {
                self.properties = response.data.properties;
            }
        });
    }

    getStatusText(status) {
        const self = this;

        let statusText = '';
        if (!status) {
        } else if (status === self.PROPERTY_STATUS_DRAFT) {
            statusText = 'Draft';
        } else if (status === self.PROPERTY_STATUS_REVIEW) {
            statusText = 'In Review';
        } else if (status === self.PROPERTY_STATUS_APPROVED) {
            statusText = 'Approved';
        } else if (status === self.PROPERTY_STATUS_REJECTED) {
            statusText = 'Rejected';
        } else if (status === self.PROPERTY_STATUS_LISTED) {
            statusText = 'Listed';
        } else if (status === self.PROPERTY_STATUS_ARCHIVED) {
            statusText = 'Archived';
        }

        return statusText;
    }

    getPublishedProperties() {
        const self = this;

        return self.getPropertiesWithStatus(self.PROPERTY_STATUS_LISTED);
    }

    getArchivedProperties() {
        const self = this;
        return self.getPropertiesWithStatus(self.PROPERTY_STATUS_ARCHIVED);
    }

    getUnPublishedProperties() {
        const self = this;

        return self.getPropertiesWithStatus([
            self.PROPERTY_STATUS_DRAFT,
            self.PROPERTY_STATUS_REVIEW,
            self.PROPERTY_STATUS_APPROVED,
            self.PROPERTY_STATUS_REJECTED,
        ]);
    }

    getPropertiesWithStatus(status) {
        const self = this;

        let statusArray = [];
        let filteredProperties = [];

        if (jQuery.isNumeric(status)) {
            statusArray = [status];
        } else if (jQuery.isArray(status)) {
            statusArray = status;
        }

        jQuery.each(self.properties, function (i, property) {
            if (statusArray.indexOf(property.status) != -1) {
                filteredProperties.push(property);
            }
        });

        return filteredProperties;
    }
}

DeveloperARMSController.$inject = ['SSHttpService', 'SSUtilService', 'SSUserService', 'SSAnalyticsService'];
app.controller('DeveloperARMSController', DeveloperARMSController);

